import type { RouteRecordRaw } from "vue-router";

import { APP_CHAT_CUSTOMER_SCHEDULE_ROUTES as SCHEDULE } from "@/Generated/Routes/paths";

import { buildBeforeEnterChain, chatCustomerGuard, fetchAppointmentGuard } from "@/Router/guards";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...SCHEDULE.root,
    component: () => import("@/Views/chat/customer/views/Schedule/index.vue"),
    meta: {
      i18nTitle: "schedule.professional.customer.title",
    },
    beforeEnter: buildBeforeEnterChain([chatCustomerGuard]),
  },
  {
    ...SCHEDULE.register.root,
    component: () => import("@/Views/schedule/views/RegisterAppointment.vue"),
    meta: {
      noHeader: true,
    },
    beforeEnter: buildBeforeEnterChain([chatCustomerGuard]),
  },
  {
    ...SCHEDULE.view.root,
    component: () => import("@/Views/schedule/views/AppointmentDetail.vue"),
    meta: {
      noHeader: true,
    },
    beforeEnter: buildBeforeEnterChain([chatCustomerGuard, fetchAppointmentGuard]),
  },
  {
    ...SCHEDULE.edit.root,
    component: () => import("@/Views/schedule/views/RegisterAppointment.vue"),
    meta: {
      noHeader: true,
    },
    beforeEnter: buildBeforeEnterChain([chatCustomerGuard, fetchAppointmentGuard]),
  },
];

export default CustomerRoutes;
